import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, ArrowRight } from 'lucide-react';
import { useT } from '../i18n';

/* Compact affiliate CTA strip — placed across the site so "others help us sell". */
export const AffiliateStrip = ({ className = '' }) => {
  const { lang } = useT();
  const isEs = lang === 'es';
  return (
    <section className={`max-w-[1280px] mx-auto px-6 lg:px-10 ${className}`} data-testid="affiliate-strip">
      <Link
        to="/affiliates"
        className="group flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-neutral-200 bg-gradient-to-r from-orange-50/80 to-white p-6 sm:p-7 hover:border-[#F77F11]/60 transition-colors"
        style={{ WebkitTapHighlightColor: 'transparent' }}
        data-testid="affiliate-strip-link"
      >
        <div className="flex items-start gap-4 min-w-0">
          <span className="w-11 h-11 rounded-xl bg-[#F77F11]/10 flex items-center justify-center shrink-0">
            <BadgeCheck className="w-5 h-5 text-[#F77F11]" />
          </span>
          <div className="min-w-0">
            <p className="font-bold text-neutral-900 text-[15.5px]">
              {isEs ? 'Conviértete en Kitxens Certified Partner™ — gana el 30% recurrente' : 'Become a Kitxens Certified Partner™ — earn 30% recurring'}
            </p>
            <p className="mt-0.5 text-[13px] text-neutral-500">
              {isEs ? 'Recomienda KITXENS a restaurantes que conozcas. Tu referido recibe 10% de descuento 1 año · cookie de 90 días · panel con transparencia total.' : 'Refer KITXENS to restaurants you know. Your referral gets 10% off for a year · 90-day cookie · dashboard with full transparency.'}
            </p>
          </div>
        </div>
        <span className="inline-flex items-center gap-1.5 text-[13.5px] font-semibold text-[#F77F11] shrink-0 group-hover:gap-2.5 transition-all">
          {isEs ? 'Certifícate gratis' : 'Get certified for free'} <ArrowRight className="w-4 h-4" />
        </span>
      </Link>
    </section>
  );
};
